import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import ClearIcon from '@material-ui/icons/Clear';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function InquiryList(props) {
  const Config = {
    purchase: {
      apiPath: '/inquiry/Order/getPageList',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/inquiry/prod/detail',
      searchBarPlaceholder: '询价编号/标题/物料名称/物料编号/物料规格',
      tabs: ['全部', '报价中', '比价中'],
      countApi: '/inquiry/Order/statisticCount',
      arrEnumField: [
        {
          mainKey: 'B02_Inquiry_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Inquiry_Bill_Type',
          subKey: 'billType',
          value: 'billTypeName'
        }
      ],
      countTransform: (data, self) => {
        //分类统计 [quoteIngCount报价中, comparePriceCount比价中]
        let { quoteIngCount: a, comparePriceCount: b } = data;
        setCount([undefined, a, b]);
      },
      tabConfig: [
        [], //全部
        [2], // 报价中
        [4] //比价中
      ]
    },
    sale: {
      apiPath: '/inquiry/customerOrder/getPageList',
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/inquiry/prod/detail',
      searchBarPlaceholder: '询价编号/标题/物料名称/物料编号/物料规格',
      tabs: ['全部', '待报价', '待客户确认', '逾期未报价'],
      countApi: '/inquiry/customerOrder/statisticCount',
      arrEnumField: [
        {
          mainKey: 'B02_Inquiry_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Quote_Status',
          subKey: 'qouteStatus',
          value: 'qouteStatusName'
        }
      ],
      countTransform: (data, self) => {
        //分类统计 [waitQuoteCount待报价, quoteWaitSignCount待客户确认]
        let { waitQuoteCount: a, quoteWaitSignCount: b } = data;
        setCount([undefined, a, b]);
      },
      tabConfig: [
        undefined, //全部
        [1, 2], // 待报价
        [2, 4] //待客户确认
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  self.beforeSearch = async function () {
    if (self.isPurchase) {
      self.searchQueries = {
        status: config.tabConfig[currentTab],
        orderStatus:
          currentTab !== '0' ? config.tabConfig[currentTab].join('') : undefined
      };
    } else {
      let cfg = {
        0: undefined, //[询价状态，报价状态]
        1: 0,
        2: 1,
        3: 2
      };
      self.searchQueries = {
        status: config.tabConfig[currentTab] || [],
        quoteStatus: cfg[currentTab]
      };
    }
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
              {searchKey && (
                <div className="searchKeyBox">
                  查询信息：
                  <div onClick={handleClear}>
                    <span className="singleOmission">{searchKey}</span>
                    <ClearIcon
                      className="verticalMiddle"
                      color="primary"
                      fontSize="inherit"
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.inqXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.inqInnerNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass(
                                'B02_Inquiry_Status',
                                item.status
                              )
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        <li>
                          <label>标题</label>
                          <div>{item.billTitle}</div>
                        </li>
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.customerName}({item.innerCustomerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label>询价类型</label>
                          <div className="blue">{item.billTypeName}</div>
                        </li>
                        <li>
                          <label>发布时间</label>
                          <div>{formatDate(item.publishTime)}</div>
                        </li>
                        <li>
                          <label>截止时间</label>
                          <div>{formatDate(item.endDate)}</div>
                        </li>
                        {!self.isPurchase ? (
                          <li>
                            <label>有效/总报价</label>
                            <div>
                              {item.validQuoteQty}&nbsp;/&nbsp;
                              {item.allQuoteQty}
                            </div>
                          </li>
                        ) : (
                          <li>
                            <label>收到邀约报价</label>
                            <div>
                              {item.qouteVendorCount}&nbsp;/&nbsp;
                              {item.vendorCount}
                            </div>
                          </li>
                        )}
                        {item.qouteStatusName && (
                          <li>
                            <label>报价状态</label>
                            <div>
                              <span
                                className={
                                  item.qouteStatus === 5
                                    ? 'green'
                                    : item.qouteStatus === 2
                                    ? 'red'
                                    : ''
                                }
                              >
                                {item.qouteStatusName}
                              </span>
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>是否入选</label>
                            <div>
                              <span
                                className={
                                  'u-sign ' +
                                  (item.quoteSelectedFlag === 0
                                    ? 'orange'
                                    : 'green')
                                }
                              >
                                {item.quoteSelectedFlag === 1
                                  ? '入选'
                                  : item.quoteSelectedFlag === 0
                                  ? '未入选'
                                  : ''}
                              </span>
                            </div>
                          </li>
                        )}
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

InquiryList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(InquiryList);
